/**
 * Checks if two objects are identical
 * This is a good method for prop checking in componentDidUpdate
 */
const isIdenticalObject = (objectA: any, objectB: any) => {
  const aProps = Object.getOwnPropertyNames(objectA);
  const bProps = Object.getOwnPropertyNames(objectB);

  if (aProps.length !== bProps.length) {
    return false;
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < aProps.length; i++) {
    const propName = aProps[i];
    if (objectA[propName] !== objectB[propName]) {
      return false;
    }
  }
  return true;
};

/**
 * Breaks arrar into chunks based on a specified size
 */
const arrChunks = (arr: any[], size: number) => {
  if (!Array.isArray(arr)) {
    throw new Error('Chunk expects argument one to be type of array.');
  }

  const len = {
    length: Math.ceil(arr.length / size),
  };

  return Array.from(len).map((value, index) => (
    arr.slice(index * size, (index * size) + size)
  ));
};

// Put asyncForEach into a module
const asyncForEach = async (array: any[], callback: Function) => {
  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < array.length; index++) {
    // eslint-disable-next-line no-await-in-loop
    await callback(array[index], index, array);
  }
};

export {
  isIdenticalObject,
  arrChunks,
  asyncForEach,
};
